const is = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Hleður...',
    error: 'Villa',
    save: 'Vista',
    cancel: 'Hætta við',
    delete: 'Eyða',
    edit: 'Breyta',
    create: 'Búa til',
    add: 'Bæta við',
    remove: 'Fjarlægja',
    close: 'Loka',
    confirm: 'Staðfesta',
    apply: 'Nota',
    reset: 'Endurstilla',
    search: 'Leita',
    filter: 'Sía',
    clear: 'Hreinsa',
    back: 'Til baka',
    next: 'Næsta',
    previous: 'Fyrri',
    submit: 'Senda',
    update: 'Uppfæra',
    refresh: 'Endurnýja',
    export: 'Flytja út',
    import: 'Flytja inn',
    download: 'Hlaða niður',
    upload: 'Hlaða upp',
    print: 'Prenta',
    copy: 'Afrita',
    yes: 'Já',
    no: 'Nei',
    ok: 'Í lagi',
    done: 'Lokið',
    select: 'Velja',
    selectAll: 'Velja allt',
    deselectAll: 'Afvelja allt',
    noResults: 'Engar niðurstöður fundust',
    noData: 'Engin gögn tiltæk',
    required: 'Nauðsynlegt',
    optional: 'Valfrjálst',
    actions: 'Aðgerðir',
    details: 'Upplýsingar',
    overview: 'Yfirlit',
    summary: 'Samantekt',
    total: 'Samtals',
    all: 'Allt',
    none: 'Ekkert',
    name: 'Nafn',
    type: 'Tegund',
    status: 'Staða',
    date: 'Dagsetning',
    time: 'Tími',
    description: 'Lýsing',
    notes: 'Athugasemdir',
    comments: 'Athugasemdir',
    category: 'Flokkur',
    priority: 'Forgangur',
    nation: 'Þjóð',
    country: 'Land',
    email: 'Netfang',
    phone: 'Sími',
    address: 'Heimilisfang',
    location: 'Staðsetning',
    coordinates: 'Hnit',
    latitude: 'Breiddargráða',
    longitude: 'Lengdargráða',
    from: 'Frá',
    to: 'Til',
    createdAt: 'Búið til',
    updatedAt: 'Uppfært',
    createdBy: 'Búið til af',
    modifiedBy: 'Breytt af',
    active: 'Virkt',
    inactive: 'Óvirkt',
    enabled: 'Virkt',
    disabled: 'Óvirkt',
    showing: 'Sýni',
    of: 'af',
    page: 'Síða',
    perPage: 'á síðu',
    rows: 'raðir',
    items: 'atriði',
    results: 'niðurstöður',
    sortBy: 'Raða eftir',
    ascending: 'Hækkandi',
    descending: 'Lækkandi',
    viewAll: 'Skoða allt',
    viewDetails: 'Skoða upplýsingar',
    goBack: 'Fara til baka',
    learnMore: 'Fræðast meira',
    seeMore: 'Sjá meira',
    showMore: 'Sýna meira',
    showLess: 'Sýna minna',
    expandAll: 'Stækka allt',
    collapseAll: 'Fella saman allt',
    copied: 'Afritað!',
    saved: 'Vistað!',
    deleted: 'Eytt!',
    updated: 'Uppfært!',
    created: 'Búið til!',
    success: 'Tókst',
    warning: 'Viðvörun',
    info: 'Upplýsingar',
    danger: 'Hætta',
    unknown: 'Óþekkt',
    notAvailable: 'Á/E',
    never: 'Aldrei',
    today: 'Í dag',
    yesterday: 'Í gær',
    tomorrow: 'Á morgun',
    now: 'Núna',
    ago: 'síðan',
    justNow: 'rétt í þessu',
    minutesAgo: '{{count}}m síðan',
    hoursAgo: '{{count}}klst síðan',
    daysAgo: '{{count}}d síðan',
    monthsAgo: '{{count}}mán síðan',
    id: 'Auðkenni',
    version: 'Útgáfa',
    language: 'Tungumál',
    theme: 'Þema',
    darkMode: 'Dökkt þema',
    lightMode: 'Ljóst þema',
    failedToLoad: 'Ekki tókst að hlaða gögnum',
    failedToSave: 'Ekki tókst að vista',
    failedToDelete: 'Ekki tókst að eyða',
    failedToUpdate: 'Ekki tókst að uppfæra',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessu?',
    confirmAction: 'Ertu viss?',
    unsavedChanges: 'Þú átt óvistaðar breytingar. Ertu viss um að þú viljir fara?',
    pageNotFound: '404 - Síða fannst ekki',
    pageNotFoundDesc: 'Síðan sem þú leitar að er ekki til.',
    backToDashboard: 'Til baka á yfirlitssíðu',
    characters: 'stafir',
    maxCharacters: 'Hámark {{max}} stafir',
    remaining: '{{count}} eftir',
    selected: '{{count}} valið',
    of_total: '{{count}} af {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Yfirlitssíða',
    requests: 'Beiðnir',
    transports: 'Flutningar',
    myPatients: 'Mínir sjúklingar',
    statistics: 'Tölfræði',
    flow: 'Flæði',
    resources: 'Resources',
    exercise: 'Æfing',
    administration: 'Stjórnun',
    map: 'Kort',
    info: 'Upplýsingar',
    users: 'Notendur',
    assets: 'Eignir',
    hubs: 'Miðstöðvar',
    treatmentFacilities: 'Meðferðarstöðvar',
    patientImport: 'Innflutningur sjúklinga',
    assetTemplates: 'Eignasniðmát',
    dayTemplates: 'Dagssniðmát',
    announcementTicker: 'Tilkynningaborði',
    exerciseStatistics: 'Æfingatölfræði',
    settings: 'Stillingar',
    auditLog: 'Eftirlitsskrá',
    exerciseControl: 'Æfingastjórn',
    dataSync: 'Gagnasamstilling',
    documentation: 'Skjölun',
    support: 'Aðstoð',
    about: 'Um kerfið',
    assetContracts: 'Asset Contracts',
    notifications: 'Tilkynningar',
    schedules: 'Áætlanir',
    capacityPlanning: 'Afkastaskipulag',
    transportPlanning: 'Flutningaskipulag',
    transportBooking: 'Flutningabókun',
    flowDiagram: 'Flæðirit',
    changePassword: 'Breyta lykilorði',
    missions: 'Verkefni',
    startPoints: 'Upphafspunktar',
    hospital: 'Sjúkrahús',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Innskráning',
    logout: 'Útskráning',
    logoutNow: 'Skrá út núna',
    loggingIn: 'Skrái inn...',
    loginFailed: 'Innskráning mistókst',
    email: 'Netfang',
    password: 'Lykilorð',
    username: 'Notandanafn',
    enterEmail: 'Sláðu inn netfangið þitt',
    enterPassword: 'Sláðu inn lykilorðið þitt',
    enterUsername: 'Sláðu inn notandanafnið þitt',
    forgotPassword: 'Gleymt lykilorð?',
    forgotPasswordTitle: 'Gleymt lykilorð',
    forgotPasswordDesc: 'Sláðu inn notandanafn og netfang. Ef bæði stemma verður kerfisstjórum tilkynnt um endurstillingu lykilorðs.',
    requestPasswordReset: 'Óska eftir endurstillingu lykilorðs',
    sending: 'Sendi...',
    backToLogin: 'Til baka í innskráningu',
    pleaseWait: 'Vinsamlegast bíðið áður en reynt er aftur.',
    requestFailed: 'Beiðni mistókst',
    credentialsMatch: 'Ef auðkennin stemma hefur kerfisstjórum verið tilkynnt.',
    forAccess: 'Fyrir aðgang, vinsamlegast hafið samband við kerfisstjóra.',
    changePassword: 'Breyta lykilorði',
    currentPassword: 'Núverandi lykilorð',
    newPassword: 'Nýtt lykilorð',
    confirmPassword: 'Staðfesta lykilorð',
    passwordChanged: 'Lykilorði breytt',
    passwordMismatch: 'Lykilorð stemma ekki',
    passwordTooShort: 'Lykilorð verður að vera að minnsta kosti 8 stafir',
    changingPassword: 'Breyti...',
    mustChangePassword: 'Þú verður að breyta lykilorðinu þínu áður en þú heldur áfram.',
    sessionExpiring: 'Seta rennur út',
    sessionExpireText: 'Setan þín rennur út eftir <strong>{{time}}</strong>. Vinsamlegast vistaðu vinnuna þína og skráðu þig inn aftur til að halda áfram.',
    dismiss: 'Hafna',
    switchNation: 'Skipta um þjóð',
    returnTo: 'Fara til baka til {{nation}}',
    viewingAs: 'Þú skoðar sem',
    loggedInAs: 'skráð/ur inn sem {{nation}}',
    trainingMode: 'AÐEINS Í ÞJÁLFUNARSKYNI',
    dedication: 'Búið til af ástríðu og holltu starfsins',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Kerfisstjóri',
    excon: 'Æfingastjóri',
    eu: 'ESB samhæfingaraðili',
    planner: 'Skipuleggjandi',
    hub: 'Miðstöðvarstjóri',
    nation: 'Þjóð',
    readOnly: 'Lesa eingöngu',
    systemAdmin: 'Kerfisstjóri',
    transportPlanner: 'Flutningaskipuleggjandi',
    systemRoles: 'Kerfishlutverk',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Drög',
    underReview: 'Í skoðun',
    published: 'Birt',
    underSelection: 'Í vali',
    accepted: 'Samþykkt',
    planned: 'Skipulagt',
    inTransit: 'Í flutningi',
    completed: 'Lokið',
    closed: 'Lokað',
    withdrawn: 'Afturkallað',
    pending: 'Í bið',
    rejected: 'Hafnað',
    cancelled: 'Hætt við',
    active: 'Virkt',
    inactive: 'Óvirkt',
    review: 'Skoðun',
    selection: 'Val',
    transit: 'Flutningur',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Starfsfólk',
    material: 'Efni',
    equipment: 'Búnaður',
    other: 'Annað',
    news: 'Fréttir',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Reglubundið',
    priority: 'Forgangur',
    urgent: 'Brýnt',
    immediate: 'Tafarlaust',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Lest',
    ship: 'Skip',
    aircraft: 'Flugvél',
    bus: 'Rúta',
    ambulance: 'Sjúkrabíll',
    drone: 'Dróni',
    helicopter: 'Þyrla',
    ferry: 'Ferja',
    other: 'Annað',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Yfirlitssíða',
    goodMorning: 'Góðan daginn',
    goodAfternoon: 'Góðan dag',
    goodEvening: 'Gott kvöld',
    lastLogin: 'Síðasta innskráning',
    infrastructure: 'Innviðir',
    transportAssets: 'Flutningseignir',
    treatmentFacilities: 'Meðferðarstöðvar',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Tölfræði beiðna',
    viewAllRequests: 'Skoða allar beiðnir',
    availableAssets: 'Tiltækar eignir',
    seated: 'Sitjandi',
    lying: 'Liggjandi',
    intensive: 'Gjörgæsla',
    notifications: 'Tilkynningar',
    markAllRead: 'Merkja allt lesið',
    noNotifications: 'Engar tilkynningar enn',
    notifiedWhenActivity: 'Þú færð tilkynningu þegar ný virkni á sér stað',
    viewDetailsBtn: 'Skoða upplýsingar',
    nationUsers: 'Þjóðarnotendur',
    user: 'Notandi',
    roles: 'Hlutverk',
    noUsersFound: 'Engir notendur fundust',
    participatingNations: 'Þátttökuþjóðir',
    exerciseDisclaimer: 'Þetta kerfi er eingöngu til æfingarnota. Sláðu eingöngu inn hermd æfingagögn. Verkferlar eru aðlagaðir að æfingatilvikinu og geta verið frábrugðnir raunverulegum aðferðum. Reglur um upplýsingatækniöryggi og persónuvernd gilda áfram að fullu.',
    notConfigured: 'Ekki stillt',
    requestCount: '{{count}} beiðni(r)',
    clickToView: 'Smella til að skoða',
    systemAdministration: 'Kerfisstjórnun',
    exerciseControlTitle: 'Æfingastjórn',
    euCoordination: 'ESB samhæfing',
    transportPlanningTitle: 'Flutningaskipulag',
    hubManagement: 'Miðstöðvarstjórn',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Ný beiðni',
    myDrafts: 'Mín drög',
    pendingReview: 'Bíður skoðunar',
    activeTransports: 'Virkir flutningar',
    myPatients: 'Mínir sjúklingar',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Beiðnir',
    newRequest: 'Ný beiðni',
    createRequest: 'Búa til beiðni',
    editRequest: 'Breyta beiðni',
    requestDetail: 'Upplýsingar um beiðni',
    requestId: 'Auðkenni beiðni',
    fromNation: 'Frá þjóð',
    toNation: 'Til þjóðar',
    requestingNation: 'Beiðniþjóð',
    receivingNation: 'Móttökuþjóð',
    category: 'Flokkur',
    urgency: 'Brýni',
    status: 'Staða',
    patients: 'Sjúklingar',
    patientCount: 'Fjöldi sjúklinga',
    offers: 'Tilboð',
    offerCount: 'Fjöldi tilboða',
    created: 'Búið til',
    updated: 'Uppfært',
    submittedBy: 'Sent af',
    reviewedBy: 'Skoðað af',
    description: 'Lýsing',
    medicalDetails: 'Læknisfræðilegar upplýsingar',
    transportDetails: 'Flutningsupplýsingar',
    additionalInfo: 'Viðbótarupplýsingar',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Brottfararstaður',
    arrivalPoint: 'Komustaður',
    estimatedDeparture: 'Áætluð brottför',
    estimatedArrival: 'Áætluð koma',
    submitForReview: 'Senda til skoðunar',
    publish: 'Birta',
    startSelection: 'Hefja val',
    acceptOffer: 'Samþykkja tilboð',
    markInTransit: 'Merkja í flutningi',
    markCompleted: 'Merkja lokið',
    closeRequest: 'Loka beiðni',
    withdrawRequest: 'Afturkalla beiðni',
    withdraw: 'Afturkalla',
    revertToDraft: 'Snúa aftur í drög',
    deleteRequest: 'Eyða beiðni',
    duplicateRequest: 'Tvítaka beiðni',
    createFollowUp: 'Búa til sameinaða beiðni',
    followUpRequest: 'Sameinuð beiðni',
    parentRequest: 'Upprunaleg beiðni',
    childRequests: 'Sameinaðar beiðnir',
    noRequests: 'Engar beiðnir fundust',
    noOffers: 'Engin tilboð enn',
    addPatient: 'Bæta við sjúklingi',
    removePatient: 'Fjarlægja sjúkling',
    patientDetails: 'Upplýsingar um sjúkling',
    contactPerson: 'Tengiliður',
    contactPhone: 'Símanúmer tengiliðar',
    contactEmail: 'Netfang tengiliðar',
    specialRequirements: 'Sérstakar kröfur',
    medicalEquipment: 'Læknisbúnaður',
    accompaniment: 'Fylgd',
    timeline: 'Tímalína',
    history: 'Saga',
    addComment: 'Bæta við athugasemd',
    writeComment: 'Skrifa athugasemd...',
    postComment: 'Birta athugasemd',
    posting: 'Birti...',
    noComments: 'Engar athugasemdir enn',
    coverageBar: 'Umfang',
    covered: 'tryggt',
    uncovered: 'ótryggt',
    filterByStatus: 'Sía eftir stöðu',
    filterByCategory: 'Sía eftir flokki',
    filterByNation: 'Sía eftir þjóð',
    searchRequests: 'Leita að beiðnum...',
    confirmWithdraw: 'Ertu viss um að þú viljir afturkalla þessa beiðni?',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessari beiðni?',
    confirmPublish: 'Ertu viss um að þú viljir birta þessa beiðni? Hún verður sýnileg öllum þjóðum.',
    confirmStartSelection: 'Ertu viss um að þú viljir hefja val? Þjóðir geta þá gert tilboð.',
    warningStartSelection: 'Að hefja val gerir þessa beiðni sýnilega öllum þátttökuþjóðum. Þær geta sent tilboð í sjúklingana í þessari beiðni. Ekki er hægt að afturkalla þessa aðgerð.',
    warningMakeOffer: 'Með því að senda þetta tilboð skuldbindur þú þjóð þína til að veita fyrirhugaða aðstoð. Þessi aðgerð tilkynnir beiðniþjóðinni og æfingastjórn.',
    saveDraft: 'Vista drög',
    saving: 'Vista...',
    saveAndSubmit: 'Vista og senda',
    step: 'Skref {{number}}',
    generalInfo: 'Almennar upplýsingar',
    patientInfo: 'Sjúklingaupplýsingar',
    logisticsInfo: 'Flutningaupplýsingar',
    reviewSubmit: 'Yfirfara og senda',
    requestTitle: 'Titill beiðni',
    requestDescription: 'Lýsing beiðni',
    numberOfPatients: 'Fjöldi sjúklinga',
    typeOfAssistance: 'Tegund aðstoðar',
    medicalTreatment: 'Læknismeðferð',
    transportAssistance: 'Flutningsaðstoð',
    both: 'Hvort tveggja',
    treatmentOnly: 'Eingöngu meðferð',
    transportOnly: 'Eingöngu flutningur',
    validationErrors: 'Vinsamlegast lagfærðu eftirfarandi villur:',
    fieldRequired: 'Þessi reitur er nauðsynlegur',
    selectExitHub: 'Veldu útgöngumiðstöð',
    createExitHub: 'Búa til útgöngumiðstöð',
    backToRequests: 'Til baka í beiðnir',
    noRequestsFound: 'Engar beiðnir fundust',
    createFirstRequest: 'Búðu til þína fyrstu beiðni til að byrja',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Tilboð',
    createOffer: 'Búa til tilboð',
    makeOffer: 'Gera tilboð',
    manageOffers: 'Stjórna tilboðum',
    offerDetail: 'Upplýsingar um tilboð',
    offerId: 'Auðkenni tilboðs',
    offeringNation: 'Tilboðsþjóð',
    offerType: 'Tegund tilboðs',
    treatment: 'Meðferð',
    transport: 'Flutningur',
    combined: 'Sameinað',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Meðferðartilboð',
    transportOffer: 'Flutningstilboð',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Velja sjúklinga',
    selectedPatients: 'Valdir sjúklingar',
    patientSelection: 'Val sjúklinga',
    offerConfiguration: 'Stilling tilboðs',
    reviewOffer: 'Yfirfara tilboð',
    submitOffer: 'Senda tilboð',
    submitting: 'Sendi...',
    acceptOffer: 'Samþykkja tilboð',
    rejectOffer: 'Hafna tilboði',
    withdrawOffer: 'Afturkalla tilboð',
    noOffers: 'Engin tilboð tiltæk',
    noOffer: 'No Offer',
    offerStatus: 'Staða tilboðs',
    offerDate: 'Dagsetning tilboðs',
    transportAsset: 'Flutningseign',
    departureDate: 'Brottfarardagur',
    arrivalDate: 'Komudagur',
    treatmentFacility: 'Meðferðarstöð',
    capacity: 'Afkastageta',
    availableCapacity: 'Tiltæk afkastageta',
    totalCapacity: 'Heildarafkastageta',
    selectAsset: 'Velja eign',
    selectFacility: 'Velja stöð',
    offerNotes: 'Athugasemdir tilboðs',
    confirmAccept: 'Ertu viss um að þú viljir samþykkja þetta tilboð?',
    confirmReject: 'Ertu viss um að þú viljir hafna þessu tilboði?',
    extendTransport: 'Framlengja flutning',
    transportExtension: 'Flutningsframlenging',
    comparisonView: 'Samanburðaryfirlit',
    shortlist: 'Valið',
    addToShortlist: 'Bæta á valið',
    removeFromShortlist: 'Fjarlægja af vali',
    leaveConfirmTitle: 'Fara af þessari síðu?',
    leaveConfirmMessage: 'Þú átt óvistaðar breytingar. Ertu viss um að þú viljir fara?',
    stayOnPage: 'Vera á síðu',
    leavePage: 'Fara af síðu',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Flutningar',
    missionDetail: 'Flutningsupplýsingar',
    missionId: 'Auðkenni flutnings',
    missionStatus: 'Staða flutnings',
    createMission: 'Búa til flutning',
    overview: 'Yfirlit',
    patientsTab: 'Sjúklingar',
    transportsTab: 'Flutningsleiðir',
    treatmentTab: 'Meðferð',
    reviewTab: 'Yfirferð',
    departure: 'Brottför',
    arrival: 'Koma',
    origin: 'Uppruni',
    destination: 'Áfangastaður',
    stops: 'Viðkomur',
    addStop: 'Bæta við viðkomu',
    removeStop: 'Fjarlægja viðkomu',
    stopName: 'Nafn viðkomu',
    stopType: 'Tegund viðkomu',
    estimatedTime: 'Áætlaður tími',
    actualTime: 'Raunverulegur tími',
    asset: 'Eign',
    driver: 'Ökumaður',
    crew: 'Áhöfn',
    noMissions: 'Engir flutningar fundust',
    completeMission: 'Ljúka flutningi',
    cancelMission: 'Hætta við flutning',
    startTransport: 'Hefja flutning',
    missionChain: 'Flutningskeðja',
    linkedMissions: 'Tengdir flutningar',
    handover: 'Afhending',
    handoverPoint: 'Afhendingarstaður',
    pickupPoint: 'Söfnunarstaður',
    dropoffPoint: 'Afhendingarstaður',
    searchTransports: 'Leita að flutningum...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Sjúklingar',
    myPatients: 'Mínir sjúklingar',
    patientId: 'Auðkenni sjúklings',
    firstName: 'Fornafn',
    lastName: 'Eftirnafn',
    dateOfBirth: 'Fæðingardagur',
    age: 'Aldur',
    gender: 'Kyn',
    male: 'Karl',
    female: 'Kona',
    other: 'Annað',
    nationality: 'Þjóðerni',
    diagnosis: 'Greining',
    condition: 'Ástand',
    stable: 'Stöðugt',
    critical: 'Lífshættulegt',
    serious: 'Alvarlegt',
    treatmentNeeded: 'Meðferð nauðsynleg',
    allergies: 'Ofnæmi',
    medications: 'Lyf',
    bloodType: 'Blóðflokkur',
    weight: 'Þyngd (kg)',
    infectious: 'Smitandi',
    mentalHealth: 'Geðheilsa',
    mobility: 'Hreyfigeta',
    ambulatory: 'Gangfær',
    wheelchair: 'Hjólastóll',
    stretcher: 'Sjúkraböru',
    intensive: 'Gjörgæsla',
    oxygenRequired: 'Súrefni nauðsynlegt',
    ventilator: 'Öndunarvél',
    medicalEscort: 'Læknisfylgd',
    noPatients: 'Engir sjúklingar fundust',
    patientDetails: 'Upplýsingar um sjúkling',
    medicalHistory: 'Sjúkrasaga',
    travelDocuments: 'Ferðaskilríki',
    passport: 'Vegabréf',
    pseudonymizedId: 'Dulnefnt auðkenni',
    sensitiveData: 'Viðkvæm gögn',
    journey: 'Ferðalag sjúklings',
    assignedTo: 'Úthlutað til',
    currentLocation: 'Núverandi staðsetning',
    importPatients: 'Flytja inn sjúklinga',
    exportPatients: 'Flytja út sjúklinga',
    seated: 'Sitjandi',
    lying: 'Liggjandi',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Notendur',
    createUser: 'Búa til notanda',
    editUser: 'Breyta notanda',
    deleteUser: 'Eyða notanda',
    username: 'Notandanafn',
    displayName: 'Birtingarnafn',
    email: 'Netfang',
    password: 'Lykilorð',
    role: 'Hlutverk',
    roles: 'Hlutverk',
    nation: 'Þjóð',
    active: 'Virkur',
    lastLogin: 'Síðasta innskráning',
    createdAt: 'Búið til',
    isNation: 'Þjóð',
    isEU: 'ESB',
    isAdmin: 'Stjórnandi',
    isExcon: 'EXCON',
    isPlanner: 'Skipuleggjandi',
    isHub: 'Miðstöð',
    isReadOnly: 'Lesa eingöngu',
    noUsers: 'Engir notendur fundust',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessum notanda?',
    resetPassword: 'Endurstilla lykilorð',
    generatePassword: 'Mynda lykilorð',
    searchUsers: 'Leita að notendum...',
    userCreated: 'Notandi búinn til',
    userUpdated: 'Notandi uppfærður',
    userDeleted: 'Notanda eytt',
    selectNation: 'Veldu þjóð',
    mustChangePassword: 'Verður að breyta lykilorði við næstu innskráningu',
    flagImage: 'Fánamynd',
    exportUsers: 'Flytja út notendur',
    importUsers: 'Flytja inn notendur',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Eignir',
    createAsset: 'Búa til eign',
    editAsset: 'Breyta eign',
    deleteAsset: 'Eyða eign',
    assetName: 'Nafn eignar',
    assetType: 'Tegund eignar',
    capacitySeated: 'Afkastageta (sitjandi)',
    capacityLying: 'Afkastageta (liggjandi)',
    capacityIntensive: 'Afkastageta (gjörgæsla)',
    owner: 'Eigandi',
    operator: 'Rekstraraðili',
    baseLocation: 'Grunnstaðsetning',
    range: 'Drægni',
    speed: 'Hraði',
    noAssets: 'Engar eignir fundust',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessari eign?',
    searchAssets: 'Leita að eignum...',
    assetCreated: 'Eign búin til',
    assetUpdated: 'Eign uppfærð',
    assetDeleted: 'Eign eytt',
    exportAssets: 'Flytja út eignir',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Miðstöðvar',
    startPoints: 'Upphafspunktar',
    createHub: 'Búa til miðstöð',
    editHub: 'Breyta miðstöð',
    deleteHub: 'Eyða miðstöð',
    hubName: 'Nafn miðstöðvar',
    hubType: 'Tegund miðstöðvar',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Inngangsmiðstöð',
    airport: 'Flugvöllur',
    seaport: 'Höfn',
    railStation: 'Lestarstöð',
    roadPoint: 'Vegapunktur',
    ucpmClassification: 'UCPM flokkun',
    icaoCode: 'ICAO kóði',
    iataCode: 'IATA kóði',
    noHubs: 'Engar miðstöðvar fundust',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessari miðstöð?',
    searchHubs: 'Leita að miðstöðvum...',
    nationAssignment: 'Þjóðaúthlutun',
    assignNations: 'Úthluta þjóðum',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Meðferðarstöðvar',
    createFacility: 'Búa til stöð',
    editFacility: 'Breyta stöð',
    deleteFacility: 'Eyða stöð',
    facilityName: 'Nafn stöðvar',
    facilityType: 'Tegund stöðvar',
    hospitalName: 'Nafn sjúkrahúss',
    bedCapacity: 'Rúmgeta',
    specialties: 'Sérgreinar',
    availableBeds: 'Tiltæk rúm',
    totalBeds: 'Heildarrúm',
    contactPerson: 'Tengiliður',
    noFacilities: 'Engar meðferðarstöðvar fundust',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessari stöð?',
    searchFacilities: 'Leita að stöðvum...',
    hubNationAssignment: 'Miðstöðvar-þjóðaúthlutun',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Áætlanir',
    createSchedule: 'Búa til áætlun',
    editSchedule: 'Breyta áætlun',
    deleteSchedule: 'Eyða áætlun',
    scheduleName: 'Nafn áætlunar',
    scheduleType: 'Tegund áætlunar',
    recurring: 'Endurtekið',
    oneTime: 'Einu sinni',
    frequency: 'Tíðni',
    daily: 'Daglega',
    weekly: 'Vikulega',
    startDate: 'Upphafsdagur',
    endDate: 'Lokadagur',
    departureTime: 'Brottfarartími',
    arrivalTime: 'Komutími',
    stops: 'Viðkomur',
    addStop: 'Bæta við viðkomu',
    noSchedules: 'Engar áætlanir fundust',
    bookings: 'Bókanir',
    timeline: 'Tímalína',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Tilkynningar',
    markAllRead: 'Merkja allt lesið',
    markAsRead: 'Merkja sem lesið',
    markAsUnread: 'Merkja sem ólesið',
    noNotifications: 'Engar tilkynningar',
    viewAll: 'Skoða allar tilkynningar',
    settings: 'Tilkynningastillingar',
    emailNotifications: 'Tilkynningar í tölvupósti',
    inAppNotifications: 'Tilkynningar í kerfinu',
    notifyOn: 'Tilkynna mér um',
    requestCreated: 'Ný beiðni',
    requestPublished: 'Beiðni birt',
    requestClosed: 'Beiðni lokað',
    requestCompleted: 'Beiðni lokið',
    commentAdded: 'Ný athugasemd',
    offerReceived: 'Tilboð móttekið',
    offerAccepted: 'Tilboð samþykkt',
    statusChanged: 'Staða breytt',
    selectionStarted: 'Val hafið',
    missionCreated: 'Flutningur búinn til',
    missionStatusUpdated: 'Flutningur uppfærður',
    transportPartnerNamed: 'Flutningsaðili',
    transportExtensionReceived: 'Flutningsframlenging',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Stillingar',
    general: 'Almennt',
    system: 'Kerfi',
    email: 'Tölvupóstur',
    sync: 'Samstilling',
    security: 'Öryggi',
    appearance: 'Útlit',
    systemName: 'Kerfisheiti',
    systemEmail: 'Kerfisnetfang',
    maintenanceMode: 'Viðhaldshamur',
    readOnlyMode: 'Lesa-eingöngu hamur',
    emailEnabled: 'Tölvupóstur virkur',
    smtpHost: 'SMTP hýsill',
    smtpPort: 'SMTP gátt',
    smtpUser: 'SMTP notandi',
    smtpPassword: 'SMTP lykilorð',
    senderEmail: 'Netfang sendanda',
    senderName: 'Nafn sendanda',
    testEmail: 'Senda prufupóst',
    syncEnabled: 'Samstilling virk',
    syncUrl: 'Samstillingarslóð',
    syncApiKey: 'Samstillingar API lykill',
    settingsSaved: 'Stillingar vistaðar',
    helpdesk: 'Þjónustuborð',
    helpdeskTitle: 'Titill þjónustuborðs',
    helpdeskEmail: 'Netfang þjónustuborðs',
    helpdeskPhone: 'Sími þjónustuborðs',
    helpdeskInfo: 'Upplýsingar þjónustuborðs',
    realLifeSupport: 'Raunveruleg aðstoð',
    trainingMode: 'Þjálfunarhamur',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Eftirlitsskrár',
    action: 'Aðgerð',
    user: 'Notandi',
    target: 'Markmið',
    details: 'Upplýsingar',
    timestamp: 'Tímastimpill',
    ipAddress: 'IP-vistfang',
    noLogs: 'Engar eftirlitsskrár fundust',
    searchLogs: 'Leita í skrám...',
    filterByAction: 'Sía eftir aðgerð',
    filterByUser: 'Sía eftir notanda',
    exportLogs: 'Flytja út skrár',
    exportCsv: 'Flytja út CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Æfingastjórn',
    currentDay: 'Núverandi dagur',
    exerciseDay: 'Æfingadagur',
    nextDay: 'Næsti dagur',
    previousDay: 'Fyrri dagur',
    resetExercise: 'Endurstilla æfingu',
    startExercise: 'Hefja æfingu',
    endExercise: 'Ljúka æfingu',
    dayReset: 'Endurstilling dags',
    confirmReset: 'Ertu viss um að þú viljir endurstilla æfingadaginn? Þetta mun hreinsa öll gögn núverandi dags.',
    resetInProgress: 'Endurstilling í gangi...',
    maintenanceMode: 'Viðhaldshamur',
    enableMaintenance: 'Virkja viðhald',
    disableMaintenance: 'Slökkva á viðhaldi',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Gagnasamstilling',
    syncStatus: 'Staða samstillingar',
    lastSync: 'Síðasta samstilling',
    pendingItems: 'Bíðandi atriði',
    syncNow: 'Samstilla núna',
    syncing: 'Samstilli...',
    syncSuccess: 'Samstilling tókst',
    syncFailed: 'Samstilling mistókst',
    outbox: 'Úthólf',
    inbox: 'Innhólf',
    configuration: 'Stilling',
    targetUrl: 'Markslóð',
    apiKey: 'API lykill',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Kort',
    layers: 'Lög',
    requests: 'Beiðnir',
    hubs: 'Miðstöðvar',
    facilities: 'Stöðvar',
    routes: 'Leiðir',
    showAll: 'Sýna allt',
    hideAll: 'Fela allt',
    zoomIn: 'Stækka',
    zoomOut: 'Minnka',
    resetView: 'Endurstilla yfirlit',
    satellite: 'Gervihnattamynd',
    terrain: 'Landslag',
    offline: 'Ótengdur',
    online: 'Tengdur',
    tilesOffline: 'Kortaflísar eru birtar staðbundið',
    tilesOnline: 'Kortaflísar eru hlaðnar frá netþjónum',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Tölfræði',
    overview: 'Yfirlit',
    requestsByStatus: 'Beiðnir eftir stöðu',
    requestsByCategory: 'Beiðnir eftir flokki',
    requestsByNation: 'Beiðnir eftir þjóð',
    offersByStatus: 'Tilboð eftir stöðu',
    patientsByCondition: 'Sjúklingar eftir ástandi',
    transportsByStatus: 'Flutningar eftir stöðu',
    timeline: 'Tímalína',
    totalRequests: 'Heildarfjöldi beiðna',
    totalOffers: 'Heildarfjöldi tilboða',
    totalPatients: 'Heildarfjöldi sjúklinga',
    totalTransports: 'Heildarfjöldi flutninga',
    averageResponseTime: 'Meðalviðbragðstími',
    completionRate: 'Hlutfall lokinna',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Æfingatölfræði',
    overview: 'Yfirlit',
    byCategory: 'Eftir flokki',
    byNation: 'Eftir þjóð',
    byDay: 'Eftir degi',
    totalPatientsMoved: 'Heildarfjöldi fluttra sjúklinga',
    totalRequestsProcessed: 'Heildarfjöldi afgreiddra beiðna',
    averageProcessingTime: 'Meðal afgreiðslutími',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Flæðirit',
    sankey: 'Sankey',
    nodeGraph: 'Hnútagraf',
    refresh: 'Endurnýja',
    noData: 'Engin flæðigögn tiltæk',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Um kerfið',
    version: 'Útgáfa',
    systemInfo: 'Kerfisupplýsingar',
    buildDate: 'Smíðadagsetning',
    environment: 'Umhverfi',
    description: 'ARCOS — Ítarlegt beiðna- og samskiptakerfi',
    subtitle: 'Slysaaðstoð og læknisaðgerðir',
    whatIsArcos: 'Hvað er ARCOS? – Útskýring fyrir þátttakendur í æfingu',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Stuðning frá MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – þar sem forvitni mætist samstarfi.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Skjölun',
    gettingStarted: 'Byrjun',
    userGuide: 'Notendahandbók',
    faq: 'Algengar spurningar',
    troubleshooting: 'Úrræðaleit',
    apiReference: 'API tilvísun',
    downloadTemplate: 'Hlaða niður sniðmáti',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Innflutningur sjúklinga',
    uploadFile: 'Hlaða upp skrá',
    selectFile: 'Velja skrá',
    preview: 'Forskoðun',
    importNow: 'Flytja inn núna',
    importing: 'Flytur inn...',
    importSuccess: '{{count}} sjúklingar fluttir inn',
    importFailed: 'Innflutningur mistókst',
    downloadTemplate: 'Hlaða niður sniðmáti',
    dragDrop: 'Dragðu og slepptu skrá hér, eða smelltu til að velja',
    supportedFormats: 'Studd snið: XLSX, XLS, CSV',
    rowsFound: '{{count}} raðir fundust',
    validRows: '{{count}} gildar raðir',
    invalidRows: '{{count}} ógildar raðir',
    duplicateRows: '{{count}} tvíteknar raðir',
    previewData: 'Forskoða gögn',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Flutningaskipulag',
    planRoute: 'Skipuleggja leið',
    routeBuilder: 'Leiðarsmíði',
    addWaypoint: 'Bæta við viðkomustað',
    removeWaypoint: 'Fjarlægja viðkomustað',
    estimatedDuration: 'Áætlaður tími',
    distance: 'Vegalengd',
    selectVehicle: 'Velja farartæki',
  },

  transportBooking: {
    title: 'Flutningabókun',
    bookTransport: 'Bóka flutning',
    availableSlots: 'Tiltæk tímabil',
    bookingConfirmed: 'Bókun staðfest',
    cancelBooking: 'Hætta við bókun',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Afkastaskipulag',
    totalCapacity: 'Heildarafkastageta',
    usedCapacity: 'Notuð afkastageta',
    availableCapacity: 'Tiltæk afkastageta',
    utilizationRate: 'Nýtingarhlutfall',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Eignasniðmát',
    dayTemplates: 'Dagssniðmát',
    createTemplate: 'Búa til sniðmát',
    editTemplate: 'Breyta sniðmáti',
    deleteTemplate: 'Eyða sniðmáti',
    templateName: 'Nafn sniðmáts',
    applyTemplate: 'Nota sniðmát',
    noTemplates: 'Engin sniðmát fundust',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessu sniðmáti?',
    confirmApply: 'Ertu viss um að þú viljir nota þetta sniðmát? Þetta mun yfirskrifa núverandi gögn.',
    exportTemplates: 'Flytja út sniðmát',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Tilkynningaborði',
    createAnnouncement: 'Búa til tilkynningu',
    editAnnouncement: 'Breyta tilkynningu',
    deleteAnnouncement: 'Eyða tilkynningu',
    message: 'Skilaboð',
    startTime: 'Upphafstími',
    endTime: 'Lokatími',
    active: 'Virkt',
    noAnnouncements: 'Engar tilkynningar',
    confirmDelete: 'Ertu viss um að þú viljir eyða þessari tilkynningu?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Leita...',
      noResults: 'Engar niðurstöður fundust',
      showing: 'Sýni {{from}} til {{to}} af {{total}}',
      rowsPerPage: 'Raðir á síðu',
      previousPage: 'Fyrri síða',
      nextPage: 'Næsta síða',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Staðfesta',
      cancel: 'Hætta við',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Óvistaðar breytingar',
      message: 'Þú átt óvistaðar breytingar. Ertu viss um að þú viljir fara af þessari síðu?',
      stay: 'Vera á síðu',
      leave: 'Fara af síðu',
    },
    // EmptyState
    emptyState: {
      noData: 'Engin gögn tiltæk',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Eitthvað fór úrskeiðis',
      message: 'Óvænt villa kom upp. Vinsamlegast reyndu að endurnýja síðuna.',
      retry: 'Reyna aftur',
    },
    // ExportButton
    exportButton: {
      export: 'Flytja út',
      exporting: 'Flytur út...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Prenta',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Drög',
      review: 'Skoðun',
      published: 'Birt',
      selection: 'Val',
      inTransit: 'Í flutningi',
      completed: 'Lokið',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Nettilvik',
      message: 'Lesa-eingöngu hamur. Gögn eru samstillt frá aðalþjóni.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Þú skoðar sem',
      loggedInAs: 'skráð/ur inn sem {{nation}}',
      returnTo: 'Fara til baka til {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Leita að síðum, beiðnum, flutningum...',
      searching: 'Leita...',
      noResults: 'Engar niðurstöður fyrir "{{query}}"',
      navigate: 'Fletta',
      select: 'Velja',
      close: 'Loka',
      pages: {
        dashboard: 'Yfirlitssíða',
        requests: 'Beiðnir',
        transports: 'Flutningar',
        map: 'Kort',
        myPatients: 'Mínir sjúklingar',
        flowDiagram: 'Flæðirit',
        statistics: 'Tölfræði',
        assets: 'Eignir',
        startPoints: 'Upphafspunktar / Miðstöðvar',
        treatmentFacilities: 'Meðferðarstöðvar',
        users: 'Notendur',
        settings: 'Stillingar',
        auditLogs: 'Eftirlitsskrár',
        exerciseControl: 'Æfingastjórn',
        dataSync: 'Gagnasamstilling',
        patientImport: 'Innflutningur sjúklinga',
        notifications: 'Tilkynningar',
        documentation: 'Skjölun',
      },
      actions: {
        importPatientsJson: 'Flytja inn Sjúklinga (JSON)',
        importPatientsExcel: 'Flytja inn Sjúklinga (Excel)',
        importUsers: 'Flytja inn Notendur (Excel)',
        importAssetTemplates: 'Flytja inn Eignasniðmát (Excel)',
        importDayTemplates: 'Flytja inn Dagssniðmátsfærslur (Excel)',
        exportRequests: 'Flytja út Beiðnir (Excel)',
        exportPatients: 'Flytja út Sjúklinga (Excel)',
        exportUsers: 'Flytja út Notendur (Excel)',
        exportCredentials: 'Flytja út Auðkenni (PDF)',
        exportAuditExcel: 'Flytja út Endurskoðunarskrá (Excel)',
        exportAuditPdf: 'Flytja út Endurskoðunarskrá (PDF)',
        pagePatientImport: 'Síða fyrir innflutning sjúklinga',
        pageRequestDetail: 'Síða fyrir upplýsingar um beiðni',
        pageUsers: 'Síða fyrir notendastjórnun',
        pageAssetTemplates: 'Síða fyrir eignasniðmát',
        pageDayTemplates: 'Síða fyrir dagssniðmát',
        pageRequests: 'Síða fyrir beiðnalista',
        pageAuditLogs: 'Síða fyrir endurskoðunarskrá',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Seta rennur út',
      message: 'Setan þín rennur út eftir <strong>{{time}}</strong>. Vinsamlegast vistaðu vinnuna þína og skráðu þig inn aftur til að halda áfram.',
      dismiss: 'Hafna',
      logoutNow: 'Skrá út núna',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Veldu 4 tímabelti',
      configure: 'Stilla tímabelti',
      reset: 'Endurstilla',
      apply: 'Nota',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Velja staðsetningu',
      latitude: 'Breiddargráða',
      longitude: 'Lengdargráða',
      clickToSelect: 'Smelltu á kortið til að velja staðsetningu',
    },
    // Modal
    modal: {
      close: 'Loka',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Heim',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Kerfisviðhald',
    message: 'Verið er að endurstilla kerfið fyrir næsta æfingadag. Vinsamlegast bíðið þar til ferlinu er lokið.',
    autoRefresh: 'Þessi síða endurnýjast sjálfkrafa þegar kerfið er aðgengilegt aftur.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Að minnsta kosti 10 stafir',
    uppercase: '1 hástafur',
    lowercase: '1 lágstafur',
    digit: '1 tölustafur',
    special: '1 sérstafur',
  },
};

export default is;
